import type { ReactNode } from 'react'
import { Outlet } from 'react-router'
import { ErrorBox } from '@/components/commons/error-box'
import { Container } from '@/components/ui/container'
import { AlertTriangleIcon } from '@/components/ui/icons'
import { ErrorBoundary } from '@/error-boundary'
import { OpsVettingHeader } from '@/features/ops-vetting/components/ops-vetting-header'
import { OpsVettingURLParams } from '@/features/ops-vetting/types'
import { ServiceVettingHeaderEndSlot } from '@/features/service-vetting/components/service-vetting-header-end-slot'
import { useGetService } from '@/features/service-vetting/query/use-get-service.ts'
import { useURLParsedParams } from '@/hooks/use-url-parsed-params'
import { ServiceVettingSteps } from '@/routes'
import { useTranslation } from '@/translations/i18n'

export const ServiceVetting = () => {
	const { t } = useTranslation()
	const urlParams = useURLParsedParams(OpsVettingURLParams)

	return urlParams.success ? (
		<OpsVettingDataInitializer vettingId={urlParams.data.id}>
			<ErrorBoundary>
				<div className='grid h-full grid-cols-[minmax(0,1fr)] grid-rows-[auto_minmax(0,1fr)] overflow-hidden'>
					<Container fullWidth>
						<OpsVettingHeader
							endSlot={
								<ServiceVettingHeaderEndSlot
									vettingId={urlParams.data.id}
								/>
							}
							steps={ServiceVettingSteps}
							title={t('vetting:service_vetting')}
							vettingId={urlParams.data.id}
						/>
					</Container>
					<Outlet context={{ urlParams: urlParams.data }} />
				</div>
			</ErrorBoundary>
		</OpsVettingDataInitializer>
	) : (
		<ErrorBox
			icon={<AlertTriangleIcon />}
			title={t('errors:invalid_url')}
		/>
	)
}

export const OpsVettingDataInitializer = ({
	vettingId,
	children
}: {
	vettingId: OpsVettingURLParams['id']
	children: ReactNode
}) => {
	useGetService(vettingId)
	return children
}
